export default {
  apiDeckIntegration: null,
  apiDeckError: null,
  routeNameAfterIntegration: null,
  isExternalApiDeckIntegrationComplete: null
}
